import React, { Suspense } from 'react'
import { useUser } from '@fs/zion-user'
import OverviewSkeleton from './Skeleton'

const LoggedInPage = React.lazy(() => import('./LoggedInPage'))
const LoggedOutPage = React.lazy(() => import('./LoggedOutPage'))

export default function OverviewPage() {
  const user = useUser()
  const { userLoading, signedIn } = user

  if (userLoading) return <OverviewSkeleton />

  const Page = signedIn ? LoggedInPage : LoggedOutPage

  return (
    <Suspense fallback={<OverviewSkeleton />}>
      <Page user={user} />
    </Suspense>
  )
}
